import {
  BaseFormViewModel,
} from '../../types';
import {
  FieldFile, FieldFileCommonTypes,
} from '../../../components/GeneralFormView/FormField/types';
import {
  BranchFeatureDTO,
} from './branchFeatureDTO';

export class BranchFeatureFormViewModel extends BaseFormViewModel<BranchFeatureDTO> {
  branchFeatureId: number;

  icon: FieldFile [];

  title: string;

  constructor(dto: BranchFeatureDTO) {
    super();
    const {
      branchFeatureId,
      iconURL,
      title,
    } = dto;
    const icon = iconURL ? [{
      source: iconURL,
      type: FieldFileCommonTypes.IMAGE,
    }] : [];
    Object.assign(this, {
      branchFeatureId,
      icon,
      title,
    });
  }

  toDTO() {
    return {
    } as BranchFeatureDTO;
  }
}
